// Единый источник реквизитов ООО «Лизинговая компания «Т-Капитал»
// и публичных документов компании.
// Используется страницами «О компании» и «Раскрытие информации», подвалом сайта.

export type CompanyDocument = {
  title: string;
  hint: string;
  link: string;
};

export const company = {
  nameFull: 'Общество с ограниченной ответственностью «Лизинговая компания «Т-Капитал»»',
  nameShort: 'ООО «Лизинговая компания «Т-Капитал»»',
  nameFullBe: 'Таварыства з абмежаванай адказнасцю «Лiзiнгавая кампанiя «Т-Капiтал»»',
  nameShortBe: 'ТАА «Лiзiнгавая кампанiя «Т-Капiтал»»',

  unp: '194031629',
  egrNumber: '194031629',
  egrDate: '25 августа 2026 года',

  address: 'Республика Беларусь, 220062, г. Минск, пр-т Победителей, д. 133, пом. 795',

  registryNumber: '215',
  registryDate: '24 сентября 2026 года',

  charterFund: '150 000,00 (сто пятьдесят тысяч рублей 00 копеек) белорусских рублей',

  phones: ['+375 33 993-33-38'],
  email: 'leasing@tcapital.by',
  site: 'https://tcapital.by',

  workHours: ['Пн–Чт: 08:30–17:00', 'Пт: 08:30–16:30', 'Сб–Вс: выходной'],
} as const;

export const companyDocuments: CompanyDocument[] = [
  {
    title: 'Устав общества',
    hint: 'Учредительный документ ООО «Лизинговая компания «Т-Капитал»»',
    link: '/docs/tc_charter.pdf',
  },
  {
    title: 'Свидетельство о государственной регистрации',
    hint: 'УНП 194031629',
    link: '/docs/tc_certificate.pdf',
  },
  {
    title: 'Свидетельство о включении в реестр лизинговых организаций',
    hint: 'Национальный банк Республики Беларусь, № 215 от 24 сентября 2026 года',
    link: '/docs/tc_NBRB.pdf',
  },
];
